// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1_CbF","header":"ReportDetails_header__21bRx","title":"ReportDetails_title__2E-n6","left":"ReportDetails_left__2jaPS"};